/** Renders the active toast notification as an MUI Snackbar with optional action button. */
import { Snackbar, Alert, Button } from '@mui/material';
import { useToast } from '@/features/ui/hooks/useToast';

const ToastContainer = () => {
  const { toasts, hideToast } = useToast();

  // Toon alleen de laatste toast voor eenvoud, of stapel ze met MUI's Snackbar
  // In een simpele implementatie tonen we er één tegelijk.
  const activeToast = toasts[0] || null;

  if (!activeToast) return null;

  return (
    <Snackbar
      key={activeToast.id}
      open={true}
      autoHideDuration={6000}
      onClose={() => hideToast(activeToast.id)}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{ zIndex: 9999 }}
    >
      <Alert
        onClose={() => hideToast(activeToast.id)}
        severity={activeToast.type}
        variant="filled"
        sx={{
          width: '100%',
          borderRadius: 1,
          boxShadow: 3,
          fontWeight: 600,
          '& .MuiAlert-action': { alignItems: 'center' },
        }}
        action={
          activeToast.action ? (
            <Button
              color="inherit"
              size="small"
              onClick={() => {
                activeToast.action.onClick();
                hideToast(activeToast.id);
              }}
            >
              {activeToast.action.label}
            </Button>
          ) : null
        }
      >
        {activeToast.message}
      </Alert>
    </Snackbar>
  );
};

export default ToastContainer;
